define('constant/common/help',[], function () {
    return {
        createapp:{
            "1": '登录华为开发者联盟> 管理中心> 应用服务>点击“应用市场”卡片进入AppGallery Connect页面。',
            "2": '点击“我的应用“进入列表，可查看开发者帐号下的所有应用。',
            "3": '在产品列表页面，点击“新建”按钮。',
            "4": '完善创建产品列表信息，确认无误点“确定”，进入应用信息页面。',
            "5": '应用信息填写完毕后点击“保存”。',
            "6": '在弹窗中点击“确认”进入准备提交页面。',
            "7": '在软件版本目录下点击“软件包管理”，上传并选择需要提交的APK包。',
            "8": '点击“提交审核”。',
            "9": '提交成功，进入审核状态。'
        },
        updateapp:{
            "1": '登录华为开发者联盟> 管理中心> 应用服务>点击“AppGallery Connect”卡片进入AppGallery Connect页面。',
            "2": '点击“我的应用“按钮进入产品列表页面。',
            "3":'点击应用名称进入应用信息页面。',
            "4":'应用信息如：截图、描述等更新完成后点击“保存”按钮。',
            "5":'点击“版本/升级”按钮，进入新版本准备提交页面。',
            "6":'点击“从软件包获取”按钮。',
            "7":'点击“上传”按钮，上传需要升级的apk。',
            "8":'在新版本准备提交页面更新分发区域等信息。',
            "9":'确认信息无误，点击“提交审核”按钮。',
            "10":'提交成功，进入审核状态。'
        },
        promote:{
            "1": '进入管理中心，点击“我的账户”>“余额”菜单。',
            "2": '点击页面右上角“马上充值”按钮。',
            "3": '在弹出框点击“去充值”按钮。',
            "4": '在弹出框正确填写必要信息后点击“去付款”按钮。',
            "5": '在新弹出的窗口中完成支付，点击“已完成支付”按钮。',
            "6": '完成支付后，左侧导航点击“应用服务”菜单，在右侧页面点击“应用市场推广”卡片。',
            "7": '在新页面点击“新建推广任务”按钮。',
            "8": '正确填写必要信息。',
            "9": '确认信息准确无误后点击“确定”按钮。',
            "10": '提交成功。'
        },
        settle:{
            "1":'进入管理中心，点击“我的账户”>“收益”菜单。',
            "2":'点击“确认结算单”按钮。',
            "3":'“提交”结算申请。'
        },
        setdesk:{
            "1":'进入管理中心，点击“自定义桌面”按钮。',
            "2":'进入“自定义桌面”可以选择新上架的卡片，也可以取消已选的卡片。',
            "3":'进入桌面，选择左侧菜单即可看到已选择的卡片，点击卡片进入并使用对应的服务。'
        },
        teamAccount:{
            "1":'进入管理中心，点击菜单栏“设置”-“团队帐号”。',
            "2":'在团队帐号页面点击“添加成员帐号”。',
            "3":'填写成员信息如华为帐号、邮箱地址、权限有效期等，点击“下一步”。',
            "4":'设置成员角色，勾选系统管理角色或应用市场角色，点击“下一步”。',
            "5":'检查已设置的成员信息，确认无误点击“确认提交”。',
            "6":'回到团队帐号列表页，已在邀请中，您还可对该成员角色权限进行修改、删除或重新邀请。'
        }
    }
});

